























































import 'reflect-metadata'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { BlocksGettersMixin } from '@/store/modules/blocks/blocks.mixins'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import EVMBlocks from '@/components/Block/EVMBlocks.vue'
import Loader from '@/components/misc/Loader.vue'

@Component({
    components: {
        Loader,
        EVMBlocks,
    },
})
export default class EVMBlocksPage extends Mixins(BlocksGettersMixin) {
    topBlockNumber = 0
    bottomBlockNumber = 0
    totalBlocks = 0
    fetchedUniq = true
    blocksOffsets = [10, 25, 50]
    blocksOffset = this.blocksOffsets[0]
    async created() {
        await this.$root.$store.dispatch('Blocks/updateLatestBlock')
        this.totalBlocks = Number(localStorage.getItem('latestBlock'))
    }
    nextPage() {
        this.fetchedUniq = true
        this.topBlockNumber = this.bottomBlockNumber
        this.bottomBlockNumber = this.topBlockNumber - this.blocksOffset
    }

    previousPage() {
        this.fetchedUniq = true
        this.bottomBlockNumber = this.topBlockNumber
        this.topBlockNumber = this.topBlockNumber + this.blocksOffset
    }

    @Watch('topBlockNumber')
    @Watch('bottomBlockNumber')
    async safetyCall() {
        if (this.topBlockNumber > this.totalBlocks) {
            this.bottomBlockNumber =
                this.bottomBlockNumber - this.topBlockNumber + this.totalBlocks
            this.topBlockNumber = Math.min(
                this.totalBlocks,
                this.topBlockNumber
            )
        }
        if (this.bottomBlockNumber < 0) {
            this.topBlockNumber =
                this.topBlockNumber + Math.abs(this.bottomBlockNumber)
            this.bottomBlockNumber = Math.max(0, this.bottomBlockNumber)
        }
        await this.updateBlocks()
    }
    @Watch('blocksOffset')
    updateBottomBlock() {
        // this.fetchedUniq = true
        this.bottomBlockNumber = this.topBlockNumber - this.blocksOffset
    }

    @Watch('totalBlocks')
    updateTopNBottom() {
        this.topBlockNumber = this.totalBlocks
        this.bottomBlockNumber = this.totalBlocks - this.blocksOffset
    }
    get loader() {
        return this.$store.state.Blocks.fetching
    }

    updateBlocks() {
        this.$store.dispatch('Blocks/getEVMBlocks', {
            //<!-- setting value directly in store-->
            top: this.topBlockNumber,
            bottom: this.bottomBlockNumber,
        })
    }

    get blocks(): EVMBlockQueryResponse[] {
        const data = this.getEVMBlocks().sort((a, b) => {
            return parseInt(b.blockNumber) - parseInt(a.blockNumber)
        })
        const unique = [
            ...new Map(data.map((m) => [m.blockNumber, m])).values(),
        ]
        if (data.length === 2 * this.blocksOffset) {
            this.fetchedUniq = false
        }
        return unique
    }

    get isTopBlock() {
        return this.totalBlocks === this.topBlockNumber
    }
    get isBottomBlock() {
        if (this.blocksOffset === 50) {
            return this.bottomBlockNumber < 49
        } else if (this.blocksOffset === 25) {
            return this.bottomBlockNumber < 24
        } else {
            return this.bottomBlockNumber < 9
        }
    }
}
